import { MappingTable } from "@/components/MappingTable";

export const ToBeFieldMapping = () => (
  <MappingTable
    panelTestId="tobe-field-mapping-panel"
    subtitleLabel="Proposed State"
    subtitleColor="text-[#3B82F6]"
    title="To-Be Field Mapping"
    description="Enhanced field mapping with Current / New Enhancement status"
    showEnhancementStatus={true}
    showProgramFilter={false}
    showTabs={false}
    accentColor="blue"
    testIdPrefix="enh"
  />
);
